import React from "react";

const DescSkeleton = () => {
  return <div className="h-6 w-full rounded-md bg-gray-300"></div>;
};

export default DescSkeleton;
